import {
  getFilterSelectionFromLocalStorage,
  studentListFilters,
} from '../components/AssignmentClassDashboard/studentsListFilter';

let cacheInitiated = false;
export const dataIdFromObject = object => {
  switch (object.__typename) {
    case 'AssignmentStats':
      return 'AssignmentStats';
    case 'AssignmentInstanceResponse':
      return 'AssignmentInstanceResponse';
    case 'TeamsPerClass':
      return 'TeamsPerClass';
    case 'GroupedSubmissions': {
      const cacheId = `GroupedSubmissions:${
        cacheInitiated
          ? getFilterSelectionFromLocalStorage().key
          : studentListFilters[0].key
      }`;
      cacheInitiated = true;
      return cacheId;
    }
    default:
      return object.id;
  }
};
